import styled from 'styled-components';
import Table, { Props, TableCell } from './Table';

const ListWrapper = styled.div`
  ${TableCell} {
    &.MuiTableCell-root {
      border: none;
      border-bottom: ${({ theme }) =>
        `1px solid ${theme.palette.common.gray8}`};
      border-radius: 0;
      &:last-child {
        border-right: unset;
      }
      &:first-child {
        border-left: unset;
      }
    }

    &.MuiTableCell-body {
      height: 60px;
    }

    &[role='contentinfo'] {
      height: 0 !important;
      padding: 0 !important;
      border: none !important;
    }
  }
`;

const List = <T extends object>({ ...props }: Props<T>) => (
  <ListWrapper>
    <Table {...props} />
  </ListWrapper>
);

export default List;
